import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const STATES = ["open", "waiting_member", "waiting_pro", "under_review", "resolved"];
const ACTIONS = [
  { id: "no_action",            label: "No action" },
  { id: "partial_refund_demo",  label: "Partial refund (demo)", danger: true },
  { id: "full_refund_demo",     label: "Full refund (demo)", danger: true },
  { id: "kutz_credit_demo",     label: "KUTZ credit (demo)", danger: true },
  { id: "request_more_info",    label: "Request more info" },
];

export default function HQDisputes() {
  const [state, setState] = useState("open");
  const [items, setItems] = useState([]);
  const [reason, setReason] = useState({});

  const load = () => api.get(`/hq/disputes?state=${state}`).then((r) => setItems(r.data || []));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [state]);

  const act = async (rid, action) => {
    const r = reason[rid] || "";
    if (["partial_refund_demo", "full_refund_demo", "kutz_credit_demo"].includes(action) && !r.trim()) {
      toast.error("Reason required for demo money actions"); return;
    }
    try {
      await api.post(`/hq/disputes/${rid}/action`, { action, reason: r });
      toast.success(`Dispute: ${action}`); setReason({ ...reason, [rid]: "" }); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Action failed"); }
  };

  return (
    <div className="p-6" data-testid="hq-disputes">
      <p className="overline">Service disputes</p>
      <h1 className="font-display text-3xl tracking-tighter mb-6">Dispute Centre</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        {STATES.map((s) => (
          <button key={s} data-testid={`hq-dispute-filter-${s}`} onClick={() => setState(s)}
                  className={`chip text-[10px] ${state === s ? "border-gold text-gold bg-gold/5" : ""}`}>{s.replace(/_/g, " ")}</button>
        ))}
      </div>
      <div className="space-y-4">
        {items.length === 0 && <div className="border border-cream/10 p-4 text-center text-cream/50 text-xs" data-testid="hq-disputes-empty">No disputes in this state.</div>}
        {items.map((d) => (
          <div key={d.id} className="border border-cream/10 p-5" data-testid={`hq-dispute-${d.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                <p className="font-display text-lg">{d.subject}</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-cream/50">Reporter: {d.reporter_name} · Severity: {d.severity}</p>
                <p className="text-xs text-cream/80 mt-2">{d.description}</p>
                <div className="mt-2 text-[10px] uppercase tracking-[0.2em] text-cream/50 grid grid-cols-2 gap-y-1">
                  <span>Studio: {d.booking_summary?.studio_name}</span>
                  <span>Service: {d.booking_summary?.service_name} · ${d.booking_summary?.price}</span>
                  <span>Check-in: {d.booking_summary?.check_in ? new Date(d.booking_summary.check_in).toLocaleString() : "—"}</span>
                  <span>Check-out: {d.booking_summary?.check_out ? new Date(d.booking_summary.check_out).toLocaleString() : "—"}</span>
                  <span>Dispute window ends: {d.booking_summary?.dispute_window_end ? new Date(d.booking_summary.dispute_window_end).toLocaleString() : "—"}</span>
                  <span>State: {d.hq_status}</span>
                </div>
                {(d.hq_actions || []).length > 0 && (
                  <div className="mt-3 border-t border-cream/10 pt-2">
                    <p className="text-[10px] uppercase tracking-[0.2em] text-cream/40">HQ actions</p>
                    {d.hq_actions.map((a, i) => (
                      <p key={i} className="text-[10px] text-cream/70">{new Date(a.at).toLocaleString()} · {a.action}{a.reason ? ` — "${a.reason}"` : ""}</p>
                    ))}
                  </div>
                )}
              </div>
              <span className={`chip text-[10px] ${d.hq_status === "resolved" ? "border-emerald-400/40 text-emerald-300" : "border-red-400/40 text-red-300"}`}>{d.hq_status}</span>
            </div>
            {d.hq_status !== "resolved" && (
              <div className="mt-4 border-t border-cream/10 pt-3 space-y-2">
                <input placeholder="Reason / note (required for money actions)"
                       data-testid={`hq-dispute-reason-${d.id}`}
                       value={reason[d.id] || ""} onChange={(e) => setReason({ ...reason, [d.id]: e.target.value })}
                       className="w-full bg-transparent border border-cream/15 px-2 py-1 text-xs focus:border-gold outline-none" />
                <div className="flex gap-2 flex-wrap">
                  {ACTIONS.map((a) => (
                    <button key={a.id} data-testid={`hq-dispute-action-${a.id}-${d.id}`}
                            onClick={() => act(d.id, a.id)}
                            className={`chip text-[10px] hover:border-gold ${a.danger ? "border-red-300/30 text-red-300 hover:border-red-300" : ""}`}>
                      {a.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
